import {batch} from 'react-redux';
import * as ActionType from '../../constants/actionType';
import {CardStateType} from '../../constants/actionType';

export function addCard(cardId, cardName, cardType, reuseTips) {
  return {type: ActionType.ADD_CARD, cardId, cardName, cardType, reuseTips};
}

export function addCardTask(cardId, cardName, cardType, taskId, task, groupId = null, isInsertTask = false) {
  return {type: ActionType.ADD_CARD_TASK, cardId, cardName, cardType, taskId, task, groupId, isInsertTask};
}

export function batchAddTasks(newTasks) {
  return {type: CardStateType.BATCH_ADD_TASKS, newTasks};
}

export function batchAddCardTask(cardId, cardName, cardType, tasks) {
  return {type: ActionType.BATCH_ADD_CARD_TASK, cardId, cardName, cardType, tasks};
}

export function insertCardTask(cardId, cardName, cardType, taskId, task, number) {
  return {type: ActionType.INSERT_CARD_TASK, cardId, cardName, cardType, taskId, task, number};
}

export function setIsInsertCard(cardId, isInsertTask) {
  return {type: ActionType.SET_IS_INSERT_CARD, cardId, isInsertTask};
}

export function removeCardTask(cardId, taskId) {
  return {type: ActionType.REMOVE_CARD_TASK, cardId, taskId};
}

export function removeCardTasks(cardId, taskIds) {
  return {type: ActionType.REMOVE_CARD_TASKS, cardId, taskIds};
}

export function removeAllCardTask(cardId) {
  return (dispatch, getState) => {
    const {cardState} = getState();
    const taskIds = cardState.cards[cardId]?.tasks;

    dispatch({type: ActionType.REMOVE_ALL_CARD_TASKS, cardId, taskIds});
  };
}

export function removeCard(cardId) {
  return (dispatch, getState) => {
    const {cardState} = getState();
    const taskIds = cardState.cards[cardId]?.tasks;
    batch(() => {
      dispatch({type: ActionType.REMOVE_CARD, cardId, taskIds});
    });
  };
}

export function removeCards(cardIds) {
  return (dispatch, getState) => {
    const {cardState} = getState();
    const taskIds = [];
    cardIds.forEach((ID) => {
      const tasks = cardState.cards[ID]?.tasks;
      if (tasks.length) taskIds.push(...tasks);
    });
    batch(() => {
      dispatch({type: ActionType.REMOVE_CARDS, cardIds, taskIds});
    });
  };
}

export function setCardName(cardId, name) {
  return {type: ActionType.SET_CARD_NAME, cardId, name};
}

export function setIgnoredCard(cardId, isIgnored) {
  return {type: ActionType.SET_IGNORE_CARD, cardId, isIgnored};
}

export function setIgnoredCardTask(taskId, isIgnored) {
  return {type: ActionType.SET_IGNORE_CARD_TASK, taskId, isIgnored};
}

export function setTaskNumber(taskId, number) {
  return {type: ActionType.SET_TASK_NUMBER, taskId, number};
}

export function setTaskRow(taskId, row) {
  return {type: ActionType.SET_TASK_ROW, taskId, row};
}

export function setTaskColumn(taskId, column) {
  return {type: ActionType.SET_TASK_COLUMN, taskId, column};
}

export function setTaskRowTipCount(taskId, rowTipCount) {
  return {type: ActionType.SET_TASK_ROW_TIP_COUNT, taskId, rowTipCount};
}

export function setTaskColumnTipCount(taskId, columnTipCount) {
  return {type: ActionType.SET_TASK_COLUMN_TIP_COUNT, taskId, columnTipCount};
}

export function setTaskLabware(taskId, labwareID) {
  return {type: ActionType.SET_TASK_LABWARE, taskId, labwareID};
}

export function setTaskLabwareIndex(taskId, labwareIndex) {
  return {type: ActionType.SET_TASK_LABWARE_INDEX, taskId, labwareIndex};
}

export function setTaskTipPosition(taskId, tipPosition) {
  return {type: ActionType.SET_TASK_TIP_POSITION, taskId, tipPosition};
}

export function setTaskMixingPosition(taskId, mixingPosition) {
  return {type: ActionType.SET_TASK_MIXING_POSITION, taskId, mixingPosition};
}

export function setTaskMixingPositionAspirate(taskId, mixingPositionAspirate) {
  return {type: ActionType.SET_TASK_MIXING_POSITION_ASPIRATE, taskId, mixingPositionAspirate};
}

export function setTaskMixingPositionDispense(taskId, mixingPositionDispense) {
  return {type: ActionType.SET_TASK_MIXING_POSITION_DISPENSE, taskId, mixingPositionDispense};
}

export function setTaskEnableMixing(taskId, enableMixing) {
  return {type: ActionType.SET_TASK_ENABLE_MIXING, taskId, enableMixing};
}

export function setTaskMixingCycle(taskId, mixingCycle) {
  return {type: ActionType.SET_TASK_MIXING_CYCLE, taskId, mixingCycle};
}

export function setTaskMixingVolume(taskId, mixingVolume) {
  return {type: ActionType.SET_TASK_MIXING_VOLUME, taskId, mixingVolume};
}

export function setTaskSpeed(taskId, speed) {
  return {type: ActionType.SET_TASK_SPEED, taskId, speed};
}

export function setTaskRetractSpeed(taskId, retractSpeed) {
  return {type: ActionType.SET_TASK_RETRACT_SPEED, taskId, retractSpeed};
}

export function setTaskMixingSpeed(taskId, mixingSpeed) {
  return {type: ActionType.SET_TASK_MIXING_SPEED, taskId, mixingSpeed};
}

export function setTaskPrecisionDispense(taskId, precisionDispense) {
  return {type: ActionType.SET_TASK_PRECISION_DISPENSE, taskId, precisionDispense};
}

export function setTaskVolume(taskId, volume, taskType) {
  return {type: ActionType.SET_TASK_VOLUME, taskId, volume, taskType};
}

export function setTaskTipTouchOff(taskId, tipTouchOff) {
  return {type: ActionType.SET_TASK_TIP_TOUCH_OFF, taskId, tipTouchOff};
}

export function setTaskTipTouchOffDelay(taskId, tipTouchOffDelay) {
  return {type: ActionType.SET_TASK_TIP_TOUCH_OFF_DELAY, taskId, tipTouchOffDelay};
}

export function setTaskTipTouchOffHeight(taskId, tipTouchOffHeight) {
  return {type: ActionType.SET_TASK_TIP_TOUCH_OFF_HEIGHT, taskId, tipTouchOffHeight};
}

export function setTaskTipTouchOffDirectionX(taskId, tipTouchOffDirectionX) {
  return {type: ActionType.SET_TASK_TIP_TOUCH_OFF_DIRECTION_X, taskId, tipTouchOffDirectionX};
}

export function setTaskTipTouchOffDirectionY(taskId, tipTouchOffDirectionY) {
  return {type: ActionType.SET_TASK_TIP_TOUCH_OFF_DIRECTION_Y, taskId, tipTouchOffDirectionY};
}

export function setTaskDispenseAtWellSide(taskId, dispenseAtWellSide) {
  return {type: ActionType.SET_TASK_DISPENSE_AT_WELL_SIDE, taskId, dispenseAtWellSide};
}

export function setTipXPositionOffset(taskId, tipXPositionOffset) {
  return {type: ActionType.SET_TIP_X_POSITION_OFFSET, taskId, tipXPositionOffset};
}

export function setTipYPositionOffset(taskId, tipYPositionOffset) {
  return {type: ActionType.SET_TIP_Y_POSITION_OFFSET, taskId, tipYPositionOffset};
}

export function restoreCardState(state) {
  return {type: ActionType.RESTORE_CARDSTATE, state};
}

export function restoreCardStateById(card) {
  return {type: ActionType.RESTORE_CARDSTATE_BY_ID, card};
}

export function batchRestoreCardStateById(cards) {
  return {type: ActionType.BATCH_RESTORE_CARDSTATE_BY_ID, cards};
}

export function restoreCardTaskState(state) {
  return {type: ActionType.RESTORE_CARDTASKSTATE, state};
}

export function restoreCardTaskStateById(task) {
  return {type: ActionType.RESTORE_CARDTASKSTATE_BY_ID, task};
}
export function batchRestoreCardTaskStateById(tasks) {
  return {type: ActionType.BATCH_RESTORE_CARDTASKSTATE_BY_ID, tasks};
}

export function resetCardState() {
  return {type: ActionType.RESET_CARDSTATE};
}

export function resetCardTaskState() {
  return {type: ActionType.RESET_CARDTASKSTATE};
}

export function swapCardPosition(cardId, swapCardId) {
  return {type: ActionType.SWAP_CARD_POSITION, cardId, swapCardId};
}

export function swabTaskItemPosition(cardId, taskId, swapTaskId) {
  return {type: ActionType.SWAP_TASK_ITEM_POSITION, cardId, taskId, swapTaskId};
}

export function setCardIsSelected(cardId, unselectOther = true, selectStatus = true) {
  return {type: ActionType.SET_CARD_IS_SELECTED, cardId, unselectOther, selectStatus};
}

export function setAllCardIsSelected(isSelected) {
  return {type: ActionType.SET_ALL_CARD_IS_SELECTED, isSelected};
}

export function setTaskIsSelected(taskId, isSelected) {
  return {type: ActionType.SET_TASK_IS_SELECTED, taskId, isSelected};
}

export function setAllTaskIsSelected(isSelected) {
  return {type: ActionType.SET_ALL_TASK_IS_SELECTED, isSelected};
}

export function saveNormalizationStateToCard(cardId, normalizationState) {
  return {type: ActionType.SAVE_NORMALIZATION_STATE_TO_CARD, cardId, normalizationState};
}

export function addCardInvalidType(cardId, invalidType) {
  return {type: ActionType.ADD_CARD_INVALID_TYPE, cardId, invalidType};
}

export function removeCardInvalidType(cardId) {
  return {type: ActionType.REMOVE_CARD_INVALID_TYPE, cardId};
}

export function changeBulkCardTask(cardId, tasks) {
  return {type: ActionType.CHANGE_BULK_CARD_TASK, cardId, tasks};
}

export function setCardIsExpanded(cardId, isExpanded) {
  return {type: ActionType.SET_CARD_IS_EXPANDED, cardId, isExpanded};
}

export function addCardGroup(groupID, group, cardIDs) {
  return {type: ActionType.ADD_CARD_GROUP, groupID, group, cardIDs};
}

export function addCardIdsToGroupCardList(groupID, cardIDs) {
  return {type: CardStateType.GROUP_ADD_CARD_LIST, groupID, cardIDs};
}

export function removeCardGroups(groupIDs) {
  return {type: ActionType.REMOVE_CARD_GROUP, groupIDs};
}

export function removeCardGroupCards(groupID, cardIds) {
  return {type: ActionType.REMOVE_CARD_GROUP_CARDS, groupID, cardIds};
}

export function setCardGroupName(groupID, name) {
  return {type: ActionType.SET_CARD_GROUP_NAME, groupID, name};
}

export function setGroupIsExpanded(groupID, isExpanded) {
  return {type: ActionType.SET_GROUP_IS_EXPANDED, groupID, isExpanded};
}

export function setGroupIsAllExpanded() {
  return {type: ActionType.SET_GROUP_IS_ALL_EXPANDED};
}

export function restoreGroupState(state) {
  return {type: ActionType.RESTORE_GROUPSTATE, state};
}

export function resetGroupState() {
  return {type: ActionType.RESET_GROUPSTATE};
}

export function addCardByObject(cardId, cardObject) {
  return {type: ActionType.ADD_CARD_BY_OBJECT, cardId, cardObject};
}

export function setGroupIsSelected(groupId, unselectOther = true, selectStatus = true) {
  return {type: ActionType.SET_GROUP_IS_SELECTED, groupId, unselectOther, selectStatus};
}

export function setAllGroupIsSelected(isSelected) {
  return {type: ActionType.SET_ALL_GROUP_IS_SELECTED, isSelected};
}

export function batchSetTasksLocation(taskIds, labwareID) {
  return {type: ActionType.BATCH_SET_TASKS_LOCATION, taskIds, labwareID};
}

export function setHumidityLevel(taskId, humidityLevel) {
  return {
    type: ActionType.SET_HUMIDITY_LEVEL,
    taskId,
    humidityLevel,
  };
}
